import { render, staticRenderFns } from "./UpstreamTransaction.vue?vue&type=template&id=1ddba916&"
import script from "./UpstreamTransaction.vue?vue&type=script&lang=js&"
export * from "./UpstreamTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports